module.exports = __webpack_public_path__ + "img/banner.ea3b3e7f.png";